'use client'

import { useEffect } from 'react'

export const useTransparentBackground = (is3DCommerceTransparentBg: boolean) => {
  useEffect(() => {
    if (is3DCommerceTransparentBg) {
      const html = document.documentElement
      const body = document.body

      html.style.setProperty('background-color', 'transparent', 'important')
      body.style.setProperty('background-color', 'transparent', 'important')

      return () => {
        html.style.removeProperty('background-color')
        body.style.removeProperty('background-color')
      }
    }
  }, [is3DCommerceTransparentBg])
}
